






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class MobHealthBar extends Vue {
  @Prop({ type: Number, required: true })
  current!: number

  @Prop({ type: Number, required: true })
  total!: number

  get percent() {
    return (this.current / this.total * 100);
  }
};
